import * as React from 'react';
import { Res, OnlineReservationInListDTO } from 'core/api';
import { TableCompanionsIcon } from 'pos/ui';
import { DateUtils } from 'core/utils';
import classNames from 'classnames';
import { Cols, Col, Flex } from 'core/ui';

function ReservationRow({ value, selected, onSelected }: {
	value: OnlineReservationInListDTO,
	selected: boolean,
	onSelected?: (reservation: OnlineReservationInListDTO) => void
}) {

	const notes = value.Notes && selected ? <Cols>
		<Col width='*' key={value.Notes}>
			{value.Notes.split('\r\n').filter(n => n).map(n => <p key={n}>{n}</p>)}
		</Col>
	</Cols> : null;

	return <>
		<Cols onClick={onSelected ? () => onSelected(value) : () => { }}>
			<Col width='*'>
				<strong>{DateUtils.formatDate(value.StartTime, 'HH:mm')}</strong>
				<br />
				<TableCompanionsIcon value={value.Companions} />
			</Col>
			<Col width='*' className='text-right'>
				<strong>{value.Customer}</strong>
				<br />
				{Res.Web.SELECT_ONLINE_RESERVATION_LOCATION_LBL(value.Location)}
			</Col>
		</Cols>
		{notes}
	</>;
}

export function ReservationList({ headerText, items, selected, onItemSelected }:
	{
		headerText: string;
		items: OnlineReservationInListDTO[],
		selected: Nullable<OnlineReservationInListDTO>,
		onItemSelected: (reservation: OnlineReservationInListDTO) => void
	}) {

	const reservations = items.map((reservation, index) =>
		<li key={index} className={classNames({ 'selected': reservation === selected })}>
			<ReservationRow value={reservation} onSelected={onItemSelected} selected={reservation === selected} />
		</li>);

	return <Flex.Vertical>
		<Flex.Item>
			<Cols className='list-header'>
				<Col>
					{headerText}
				</Col>
			</Cols>
		</Flex.Item>
		<Flex.Item size='*'>
			<ul className='list text-18'>{reservations}</ul>
		</Flex.Item>
	</Flex.Vertical>;
}
